export default function SbImageService(imageSrc) {
  if (
    imageSrc &&
    !isSvg(imageSrc) &&
    imageSrc.startsWith("//a.storyblok.com")
  ) {
    return imageSrc.replace(
      "a.storyblok.com",
      "img2.storyblok.com"
    )
  }

  return imageSrc
}

export function isSvg(imageSrc) {
  if (imageSrc) return imageSrc.endsWith(".svg")
  return false
}
